import Projects from "./Projects";

const ExternalProjects = () => {
  return <Projects scope="External" pageTitle="External Projects" />;
};

export default ExternalProjects;
